/** Outbox / sync toasts fired outside the render tree (`offline/OutboxBridge.tsx`, SyncIndicator). */
export const offline = {
  'offline.synced': 'All changes synced.',
  'offline.syncFailed': "Some changes couldn't be saved. They'll retry.",
  'offline.paused': 'Sync paused. Sign in to resume.',
  'offline.restoredToTop': 'Restored to the top level, because its parent is still in the trash.',
  'offline.deletedPermanently.one': 'Deleted {count} page permanently.',
  'offline.deletedPermanently.other': 'Deleted {count} pages permanently.',
  'offline.pageChangedElsewhere':
    'This page changed elsewhere. Your version is safe — choose which to keep.',
  'offline.fixEventAndSave': 'Fix the event and save again.',
  'offline.settingSaveFailed': "Couldn't save that setting.",
  'offline.pageMoveConflict': "A page can't be moved inside itself.",
  'offline.syncChangeFailed': "Couldn't sync a change: {message}",
  'offline.syncChangeFailedHint': 'It is still saved on this device. Open the sync menu to retry.',
} as const;
